(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-block"] && !Shopify.designMode) return;
  try {
    function initCarousels(container) {
    var containers = container
      ? container.querySelectorAll('.iav-carousel-container')
      : document.querySelectorAll('.iav-carousel-container');

    containers.forEach(function (iav) {
      if (iav.dataset.carouselInit) return;
      iav.dataset.carouselInit = 'true';

      var track = iav.querySelector('.iav-carousel-track');
      var slides = iav.querySelectorAll('.iav-carousel-slide');
      var next = iav.querySelector('.iav-next-btn');
      var prev = iav.querySelector('.iav-prev-btn');
      var scrollbar = iav.querySelector('.iav-scrollbar');
      var scrollThumb = iav.querySelector('.iav-scroll-thumb');
      var index = 0;
      var loadedSlides = {};

      function loadSlideImage(slideIndex) {
        if (loadedSlides[slideIndex]) return;

        var slide = slides[slideIndex];
        var lazyPlaceholder = slide.querySelector('[data-lazy-placeholder]');

        if (lazyPlaceholder) {
          var imageUrl = lazyPlaceholder.dataset.imagePreview;

          var img = document.createElement('img');

          img.onload = function () {
            lazyPlaceholder.innerHTML = '';

            var wrapper = document.createElement('div');
            wrapper.className = 'responsive-image';
            wrapper.style.position = 'relative';
            wrapper.style.width = '100%';
            wrapper.style.height = '100%';

            img.style.position = 'absolute';
            img.style.top = 0;
            img.style.left = 0;
            img.style.width = '100%';
            img.style.height = '100%';
            img.style.objectFit = 'cover';

            wrapper.appendChild(img);
            lazyPlaceholder.appendChild(wrapper);
          };

          img.src = imageUrl;
          loadedSlides[slideIndex] = true;
        }
      }

      function update() {
        track.style.transform = 'translateX(' + -index * 100 + '%)';
        updateScrollbar();
        loadSlideImage(index);

        setTimeout(function () {
          var nextIndex = (index + 1) % slides.length;
          loadSlideImage(nextIndex);
        }, 200);
      }

      function updateScrollbar() {
        if (window.innerWidth <= 480 && scrollbar && scrollThumb) {
          var thumbWidth = 100 / slides.length;
          var thumbPosition = index * thumbWidth;
          scrollThumb.style.width = thumbWidth + '%';
          scrollThumb.style.left = thumbPosition + '%';
        }
      }

      if (next)
        next.addEventListener('click', function (e) {
          e.preventDefault();
          index = (index + 1) % slides.length;
          update();
        });

      if (prev)
        prev.addEventListener('click', function (e) {
          e.preventDefault();
          index = (index - 1 + slides.length) % slides.length;
          update();
        });

      let startX = 0;

      track.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
      });

      track.addEventListener('touchend', function (e) {
        let endX = e.changedTouches[0].clientX;

        if (startX - endX > 50) {
          index = (index + 1) % slides.length;
        } else if (endX - startX > 50) {
          index = (index - 1 + slides.length) % slides.length;
        }

        update();
      });

      if (scrollbar) {
        scrollbar.addEventListener('click', function (e) {
          if (window.innerWidth <= 480) {
            var rect = scrollbar.getBoundingClientRect();
            var clickX = e.clientX - rect.left;
            var percentage = clickX / rect.width;
            index = Math.floor(percentage * slides.length);
            if (index >= slides.length) index = slides.length - 1;
            update();
          }
        });
      }

      window.addEventListener('resize', function () {
        updateScrollbar();
      });

      if (slides.length > 1) {
        setTimeout(function () {
          loadSlideImage(1);
        }, 500);
      }

      update();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCarousels();
  });
  } catch(e) { console.error(e); }
})();

})();
